import Request from "../Request";

class TimeoffUserIndex {
    constructor(config) {
        this.config = Object.assign({
            scope: '[data-timeoff-user="scope"]',
            form: '[data-timeoff-user="form"]',
            list: '[data-timeoff-user="list"]',
        }, config);

        this.$scope = $(this.config.scope);

        if(this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        this.request = new Request();
        this.request.handleResponse = this.handleResponse.bind(this);

        this.$scope.on('submit', this.config.form, this.filterByForm.bind(this));
        this.$scope.on('change', `${this.config.form} input`, this.filterByInput.bind(this));
    }

    filterByForm(event) {
        event.preventDefault();
        this._filter();
    }

    filterByInput(event) {
        let $input = $(event.currentTarget);
        this.request.setByKeyValue('page', 1);
        this.request.setByKeyValue($input.attr('name'), $input.val());
        this._filter();
    }

    _filter() {
        this.request.reload();
    }

    handleResponse(response) {
        this.$scope.find(this.config.list).html(response.list);
    }
}

export default new TimeoffUserIndex;
